import Vue from 'vue'
import VueI18n from 'vue-i18n'
import locale from 'element-ui/lib/locale'

// 引入 elementui 的多语言
import enLocale from 'element-ui/lib/locale/lang/en'
import zhCnLocale from 'element-ui/lib/locale/lang/zh-CN'
import frLocal from 'element-ui/lib/locale/lang/fr'
import gmLocal from 'element-ui/lib/locale/lang/de'


// 从语言包文件中导入语言包对象
import zh from './i18n-zh'
import en from './i18n-en'
import fr from './i18n-fr'
import gm from './i18n-gm'
// 注册 vue-i18n
Vue.use(VueI18n)
 
// 默认中文
const lang = 'zh_cn'
const i18n = new VueI18n({
  locale: lang,
  messages: {
    // 会把zh的所有内容拷贝到zhCnLocale文件中
    'zh_cn': Object.assign(zhCnLocale, zh),
    'en-US': Object.assign(enLocale, en),
    'fr': Object.assign(frLocal, fr),
    'gm': Object.assign(gmLocal, gm),
    // 如果还有新的语言在下面继续添加
  }
})
 
locale.i18n((key, value) => i18n.t(key, value))
export default i18n



// WEBPACK FOOTER //
// ./src/lang/i18n.js